import { Button, DataSource, Layout, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTriumphPayTxAudit extends Layout {
    buttonUpdateSeverity: Button;
    sourceHubtranInvoiceExceptions: DataSource;
    sourceMovement: DataSource;
    tableInvExceptions: Table;
    textboxHubtranApprovedInvDate: Textbox;
    textboxHubtranOk2payDate: Textbox;
}
